import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NotifierService } from 'angular-notifier';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { EnumRoleUser } from "src/app/core/constants/common";
import { CommonService } from 'src/app/core/services/common.service';
import { ConvertCurrencyService } from 'src/app/core/services/convert-currency.service';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { DcFieldConfigService } from 'src/app/core/services/dc-field-config.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { TemplateFormService } from 'src/app/core/services/template-form.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { DocumentTypeService } from '../../../../../../../../core/services/document-type.service';



@Component({
    selector: 'app-footnote-moha',
    templateUrl: './footnote-moha.component.html',
    styleUrls: ['./footnote-moha.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
            state('*', style({ height: '*', visibility: 'visible' })),
            transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class FootNoteMohaComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

    @BlockUI() blockUI: NgBlockUI;

    dataFootNote: any = [];
    listDataPeople: any = [];

    optionsCustomer: any = [];
    optionsApprover = [];
    optionsApproverCustomer = [];
    optionsApproverCustomer1 = [];
    lengthApprover = 0;
  lengthApproverCustomer = 0;

    createSide: any = null;

  optionsSignCustomer: any = [];
  optionsSignApprover = [];
  optionsSignApproverCustomer = [];
  optionsSignEnterprise = [];
  listSign= [];

    subscription: Subscription;
    constructor(
        public commonService: CommonService,
        public message: Message,
        private notifier: NotifierService,
        public documentTemplateService: DocumentTemplateService,
        public templateFormService: TemplateFormService,
        public createContractMohaService: CreateContractMohaService,
        private toast: ToastrService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        public customerService: CustomerService,
        public documentService: DocumentService,
        public dcFieldConfig: DcFieldConfigService,
        public convertCurrencyService: ConvertCurrencyService,
        public documentTypeService: DocumentTypeService
    ) {
        super(commonService, message);
        this.notifier = notifier;
    }

    ngOnInit() {
        // this.createContractMohaService.signatureData.asObservable().subscribe(dataSign => {
        //     if (dataSign) {
        //         this.showSignatureFromData(dataSign);
        //     }
        // })
        // this.createContractMohaService.signatureData.subscribe(() => {
        //     this.showSignatureFromData();
        // })
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {

    }

    showSignatureFromData(event?) {
        const users = this.createContractMohaService.recordsPartySign.getValue();
        const data = this.createContractMohaService.signatureData.getValue();
        const checkFootNote = this.createContractMohaService.checkFootNote.getValue();
        const signatureDataSign = this.createContractMohaService.signatureDataSign.getValue();
        let checkFoote = false;
        if (!data) {
            return;
        }
        if(users.length >0){
          users.forEach(ala =>{
            if(!ala.isCreatedSide){
              if(!ala.isSetupSignFlow && ala.customerApproves){
                console.log(ala.customerApproves);
                
                delete ala.customerApproves;
              }
            }
          })
          this.createContractMohaService.recordsPartySign.next(users);
        }
        data.forEach(ele =>{
            if(ele.signature.positions.length > 0){
              ele.signature.positions.forEach(x =>{
                if(x.name){
                  checkFoote = true;
                }
              })
            }
          // if(ele.customerId || ele.userId || ele.enterpriseId){
          //   checkFoote = true;
          // }
        })
      this.optionsSignEnterprise =[];
      this.optionsSignApprover =[];
      this.optionsSignCustomer =[];
      this.optionsApproverCustomer1 =[];
      this.listSign = data;
      this.listSign.forEach(ele =>{
        if(ele.signature.object == 'ENTERPRISE'){
          this.optionsSignEnterprise.push(ele);
        }
        if(ele.signature.object == 'ENTERPRISEAPPROVER'){
          this.optionsSignApprover.push(ele);
        }
        if(ele.signature.object == 'CUSTOMER'){
          this.optionsSignCustomer.push(ele);
        }
        if(ele.signature.object == 'CUSTOMERAPPROVER'){
          this.optionsApproverCustomer1.push(ele);
        }
      })
        if(event == 1){
          this.listDataPeople.forEach(ele =>{
            ele.customerApproves.forEach(ala =>{
              const a = data.filter(bla => {
                return ala.signatureId == bla.signature.signatureId;
              });
              if(a.length >0){
                const page = [];
                a[0].signature.positions.forEach(pos => {
                  if (pos.page && !page.includes(pos.page)) {
                    page.push(pos.page);
                  }
                });
                ala.page = page.join(', ');
              }
            })
          })
          const listSignApprove = [];
          const listSignCus = [];
          const listSignCusApprove = [];
          this.listDataPeople.forEach(ele =>{
            ele.customerApproves.forEach(ala =>{
              if(ele.isCreatedSide && ala.role == 2){
                listSignApprove.push(ala);
              }
              if(!ele.isCreatedSide && ala.role == 1){
                listSignCus.push(ala);
              }
              if(!ele.isCreatedSide && (ala.role == 2 || ala.role == 7)){
                listSignCusApprove.push(ala);
              }
            })
          });
          this.dataFootNote.forEach(ele =>{
            if(ele.signature.object == 'ENTERPRISEAPPROVER'){
              if(listSignApprove.length > 0){
                const a = listSignApprove.filter(ala => {
                  return ala.signatureId == ele.signature.signatureId;
                });
                if(a.length > 0){
                  ele.signature.positions.forEach(element =>{
                    element.name = a[0].name;
                  })
                  // ele.name = a[0].name;
                  ele.userId = a[0].userId;
                }
              }
              // this.optionsSignApprover.push(ele);
            }
            if(ele.signature.object == 'CUSTOMER'){
              if(listSignCus.length > 0){
                const a = listSignCus.filter(ala => {
                  return ala.signatureId == ele.signature.signatureId;
                });
                if(a.length > 0){
                  // ele.name = a[0].name;
                  ele.signature.positions.forEach(element =>{
                    element.name = a[0].name;
                  })
                  ele.customerId = a[0].customerId;
                }
              }
              // this.optionsSignCustomer.push(ele);
            }
            if(ele.signature.object == 'CUSTOMERAPPROVER'){
              if(listSignCusApprove.length > 0){
                const a = listSignCusApprove.filter(ala => {
                  return ala.signatureId == ele.signature.signatureId;
                });
                if(a.length > 0){
                  // ele.name = a[0].name;
                  ele.signature.positions.forEach(element =>{
                    element.name = a[0].name;
                  })
                  ele.userId = a[0].userId;
                }
              }
            }
          })
        }else {
          this.blockUI.reset();
          this.blockUI.start('');
          const customers = users.filter(user => {
            return !user.isCreatedSide
          });
          const enterprise = users.find(item => item.isCreatedSide);
          const userPerformSigns = this.createContractMohaService.recordsUserPerformSign.getValue();
          const userSign = userPerformSigns.find(user => user.role === EnumRoleUser.USER_SIGN);
          this.createSide = enterprise ? userSign : null;
          this.optionsCustomer = customers;
          this.optionsCustomer.forEach(ele => {
            if (ele.customerApproves) {
              ele.customerApproves.forEach(ala => {
                this.optionsApproverCustomer.push(ala);
              })
            }
          })
          const listData = [];
          userPerformSigns.forEach(res => {
            if (res.role === EnumRoleUser.USER_APPROVER && res.isSignDigitalCertificate && (res && res.signConfig && res.signConfig.showImage)) {
              listData.push(res);
            }
          });
          this.lengthApprover = data.filter(item => {
            return item.signature.object === 'ENTERPRISEAPPROVER';
          }).length;
          this.lengthApproverCustomer = data.filter(item => {
            return item.signature.object === 'CUSTOMERAPPROVER';
          }).length;
          this.optionsApprover = listData;
          localStorage.setItem('listData1', JSON.stringify(enterprise));
          localStorage.setItem('listData2', JSON.stringify(customers));
          localStorage.setItem('listData3', JSON.stringify(userPerformSigns));
          const listData2 = JSON.parse(localStorage.getItem('listData2'));
          this.listDataPeople = [];
          if(localStorage.getItem('listData1')  != 'undefined'){
            this.listDataPeople.push(JSON.parse(localStorage.getItem('listData1')));
          }
          if (customers.length > 0){
            listData2.forEach(ele =>{
              if(ele.customerApproves){
                ele.customerApproves = ele.customerApproves.filter(ala => {return ala.CTS && ala.image})
              }
            })
            listData2.forEach(ele => {
              this.listDataPeople.push(ele);
            });
          }
          this.listDataPeople.forEach(ele => {
            if (ele.isCreatedSide) {
              ele.customerApproves = [];
              JSON.parse(localStorage.getItem('listData3')).forEach((ala, i) => {
                if ((ala.isSignDigitalCertificate && ala.signConfig.showImage)) {
                  ele.customerApproves.push(ala);
                }
                if (ala.role == 1) {
                  ele.customerApproves.push(ala);
                }
              })
            }
           else if (!ele.isCreatedSide) {
              if (ele.customerApproves && ele.customerApproves.length > 0) {
                JSON.parse(localStorage.getItem('listData2')).forEach(ala => {
                  if (ele.customerId == ala.customerId) {
                    ele.customerApproves.push(ala);
                  }
                });

              } else {
                ele.customerApproves = [];
                JSON.parse(localStorage.getItem('listData2')).forEach(ala => {
                  if (ele.customerId == ala.customerId) {
                    ele.customerApproves.push(ala);
                  }
                });
              }
            }
          })
          this.listDataPeople.forEach((ele, i) => {
            ele.customerApproves.forEach((ala, j) => {
              ala.signatureId = null;
              ala.page = '';
              if (!ala.role) {
                if (j + 1 < ele.customerApproves.length) {
                  ala.role = '2'
                } else {
                  ala.role = '1'
                }
              }
              if (ala.role == 1 && ala.isCreatedSide) {
                if (this.optionsSignEnterprise.length > 0) {
                  ala.signatureId = this.optionsSignEnterprise[0].signature.signatureId;
                  // ala.page = this.optionsSignEnterprise[0].signature.page;
                  ala.signatureName = this.optionsSignEnterprise[0].signature.name
                  if(!this.optionsSignEnterprise[0].signature.page){
                    const page = [];
                    this.optionsSignEnterprise[0].signature.positions.forEach(pos => {
                      if (pos.page && !page.includes(pos.page)) {
                        page.push(pos.page);
                      }
                    });
                    ala.page = page.join(', ');
                  }
                  else{
                    ala.page = this.optionsSignEnterprise[0].signature.page;
                  }
                }
              }

            })
          });
          const listSignApprove = [];
          const listSignCus = [];
          const listSignCusApprove = [];
          this.listDataPeople.forEach(ele => {
            ele.customerApproves.forEach(ala => {
              if (ele.isCreatedSide && ala.role == 2 && ala.isSignDigitalCertificate && ala.signConfig.showImage) {
                listSignApprove.push(ala);
              }
              if (!ele.isCreatedSide && ala.role == 1) {
                listSignCus.push(ala);
              }
              if (!ele.isCreatedSide && (ala.role == 2 || ala.role == 7)) {
                listSignCusApprove.push(ala);
              }
            })
          })
          if(checkFoote){
            if (listSignApprove.length != 0 && this.optionsSignApprover.length > 0) {
              listSignApprove.forEach((ele, i) => {
                const listSign = this.optionsSignApprover.filter(ala => {return ele.userId == ala.userId});
                if(listSign.length > 0){
                    ele.signatureId = listSign[0].signature.signatureId;
                    if(!listSign[0].signature.page){
                      const page = [];
                      listSign[0].signature.positions.forEach(pos => {
                        if (pos.page && !page.includes(pos.page)) {
                          page.push(pos.page);
                        }
                      });
                      ele.page = page.join(', ');
                    }
                    else{
                      ele.page = listSign[0].signature.page;
                    }

              }
              })
            }
            if (listSignCus.length != 0 && this.optionsSignCustomer.length > 0) {
              listSignCus.forEach((ele, i) => {
                const listSign = this.optionsSignCustomer.filter(ala => {return ele.customerId == ala.customerId});
                if(listSign.length > 0){
                  ele.signatureId = listSign[0].signature.signatureId;
                  if(!listSign[0].signature.page){
                    const page = [];
                    listSign[0].signature.positions.forEach(pos => {
                      if (pos.page && !page.includes(pos.page)) {
                        page.push(pos.page);
                      }
                    });
                    ele.page = page.join(', ');
                  }
                  else{
                    ele.page = listSign[0].signature.page;
                  }
                }
              })
            }
            if (listSignCusApprove.length != 0 && this.optionsApproverCustomer1.length > 0) {
              listSignCusApprove.forEach((ele, i) => {
                const listSign = this.optionsApproverCustomer1.filter(ala => {return ele.userId == ala.userId});
                if(listSign.length > 0){
                  ele.signatureId = listSign[0].signature.signatureId;
                  if(!listSign[0].signature.page){
                    const page = [];
                    listSign[0].signature.positions.forEach(pos => {
                      if (pos.page && !page.includes(pos.page)) {
                        page.push(pos.page);
                      }
                    });
                    ele.page = page.join(', ');
                  }
                  else{
                    ele.page = listSign[0].signature.page;
                  }
                }
              })
            }
          this.dataFootNote = data;
          }
          else {
            if (listSignApprove.length != 0 && this.optionsSignApprover.length > 0) {
              listSignApprove.forEach((ele, i) => {
                if (i < this.optionsSignApprover.length) {
                  ele.signatureId = this.optionsSignApprover[i].signature.signatureId;
                  if(!this.optionsSignApprover[i].signature.page){
                    const page = [];
                    this.optionsSignApprover[i].signature.positions.forEach(pos => {
                      if (pos.page && !page.includes(pos.page)) {
                        page.push(pos.page);
                      }
                    });
                    ele.page = page.join(', ');
                  }
                  else{
                    ele.page = this.optionsSignApprover[i].signature.page;
                  }
                }
              })
            }
            if (listSignCus.length != 0 && this.optionsSignCustomer.length > 0) { //An
              listSignCus.forEach((ele, i) => {
                  if (i < this.optionsSignCustomer.length) {
                    if(data.length>0 && window.location.href.includes('update') ){
                      data.forEach(bla=> {
                        if (bla.signature.object=="CUSTOMER" && bla.customerId && bla.customerId==ele.customerId){
                          ele.signatureId = bla.signature.signatureId;
                        }
                      })
                    } else {
                      ele.signatureId = this.optionsSignCustomer[i].signature.signatureId;
                    }
                    if(!this.optionsSignCustomer[i].signature.page){
                      const page = [];
                      this.optionsSignCustomer[i].signature.positions.forEach(pos => {
                        if (pos.page && !page.includes(pos.page)) {
                          page.push(pos.page);
                        }
                      });
                      ele.page = page.join(', ');
                    }
                    else{
                      ele.page = this.optionsSignCustomer[i].signature.page;
                    }
                  }
              })
            }
            if (listSignCusApprove.length != 0 && this.optionsApproverCustomer1.length > 0) {
              listSignCusApprove.forEach((ele, i) => {
                if (i < this.optionsApproverCustomer1.length) {
                  ele.signatureId = this.optionsApproverCustomer1[i].signature.signatureId;
                  if(!this.optionsApproverCustomer1[i].signature.page){
                    const page = [];
                    this.optionsApproverCustomer1[i].signature.positions.forEach(pos => {
                      if (pos.page && !page.includes(pos.page)) {
                        page.push(pos.page);
                      }
                    });
                    ele.page = page.join(', ');
                  }
                  else{
                    ele.page = this.optionsApproverCustomer1[i].signature.page;
                  }
                }
              })
            }
          }
          let check = false;
          let indexApprover = 1;
          let indexCustomer = 1;
          let indexCustomerApprove = 1;
          this.dataFootNote = data.map(item => {
            if (item.signature) {
              const page = [];
              if (item.signature.positions) {
                item.signature.positions.forEach(pos => {
                  if (pos.page && !page.includes(pos.page)) {
                    page.push(pos.page);
                  }
                });
              }
              item.signature.page = page.join(', ');
              if ((!item.signature.object || item.signature.object === 'CUSTOMER') && item.customerId) {
                const option = customers.find(cus => cus.customerId === item.customerId);
                if (!option) {
                  check = true;
                  item.customerId = null;
                }
              }
              if ((!item.signature.object || item.signature.object === 'ENTERPRISEAPPROVER') && item.userId) {
                const option = listData.find(cus => cus.userId === item.userId);
                if (!option) {
                  item.userId = null;
                }
              }
              if ((!item.signature.object || item.signature.object === 'CUSTOMERAPPROVER') && item.userId) {
                const option = listData.find(cus => cus.userId === item.userId);
                if (!option) {
                  item.userId = null;
                }
              }
              if (item.signature.object === 'ENTERPRISEAPPROVER') {
                item.indexApprover = indexApprover;
                indexApprover++;
              }
              if (item.signature.object === 'CUSTOMER'&& item.customerId) {
                item.indexCustomer = indexCustomer;
                indexCustomer++;
              }
              if (item.signature.object === 'CUSTOMERAPPROVER') {
                item.indexCustomerApprove = indexCustomerApprove;
                indexCustomerApprove++;
              }
            }
            return item;
          });
          this.blockUI.stop();
          this.cdr.detectChanges();
          this.dataFootNote.forEach(ele => {
            if (ele.signature.object == 'ENTERPRISEAPPROVER') {
              if (listSignApprove.length > 0) {
                const a = listSignApprove.filter(ala => {
                  return ala.signatureId == ele.signature.signatureId;
                });
                if (a.length > 0) {
                  ele.signature.positions.forEach(element => {
                    element.name = a[0].name;
                  })
                  ele.userId = a[0].userId;
                }
              }
            }
            if (ele.signature.object == 'CUSTOMER') {
              if (listSignCus.length > 0) {
                const a = listSignCus.filter(ala => {
                  return ala.signatureId == ele.signature.signatureId;
                });
                if (a.length > 0) {
                  ele.signature.positions.forEach(element => {
                    element.name = a[0].name;
                  })
                  ele.customerId = a[0].customerId;
                }
              }
            }
            if (ele.signature.object == 'CUSTOMERAPPROVER') {
              if (listSignCusApprove.length > 0) {
                const a = listSignCusApprove.filter(ala => {
                  return ala.signatureId == ele.signature.signatureId;
                });
                if (a.length > 0) {
                  ele.signature.positions.forEach(element => {
                    element.name = a[0].name;
                  })
                  ele.userId = a[0].userId;
                }
              }
            }
          })
          this.createContractMohaService.cacheCustomerForSignature = JSON.parse(JSON.stringify(customers));
          this.listDataPeople.sort(function (a,b) {
            return a.order - b.order
          });
        }
        this.createContractMohaService.signatureData.next(this.dataFootNote);
        this.createContractMohaService.signatureDataSign.next(this.listDataPeople);
        this.createContractMohaService.checkFootNote.next(true);
        return;
    }

    changeSelect(event: any, data: any,i,j) {
      localStorage.setItem('dataSignature',JSON.stringify(data));
      const listData = JSON.parse(localStorage.getItem('dataSignature'));
      if(listData.signatureId){
        this.listDataPeople.forEach((ele,a) =>{
          ele.customerApproves.forEach((ala,b) =>{
            if(ala.signatureId == listData.signatureId ){
              ala.signatureId = null;
              ala.page = '';
            }
          })
        })
        this.listDataPeople[j].customerApproves[i].signatureId = listData.signatureId;
        this.listDataPeople[j].customerApproves[i].page = this.listSign.filter(ele => {
          return ele.signature.signatureId == listData.signatureId;
        })[0].signature.page;
      }
      else {
        this.listDataPeople[j].customerApproves[i].signatureId = null;
        this.listDataPeople[j].customerApproves[i].page = '';
      }

      const listSignApprove = [];
      const listSignCus = [];
      const listSignCusApprove = [];
      this.listDataPeople.forEach(ele =>{
        ele.customerApproves.forEach(ala =>{
          if(ele.isCreatedSide && ala.role == 2){
            listSignApprove.push(ala);
          }
          if(!ele.isCreatedSide && ala.role == 1){
            listSignCus.push(ala);
          }
          if(!ele.isCreatedSide && (ala.role == 2 || ala.role == 7)){
            listSignCusApprove.push(ala);
          }
        })
      });
      this.dataFootNote.forEach(ele =>{
        if(ele.signature.object == 'ENTERPRISEAPPROVER'){
          if(listSignApprove.length > 0){
            const a = listSignApprove.filter(ala => {
              return ala.signatureId == ele.signature.signatureId;
            });
            if(a.length > 0){
              ele.signature.positions.forEach(element =>{
                element.name = a[0].name;
              })
              // ele.name = a[0].name;
              ele.userId = a[0].userId;
            }
            else {
              ele.userId = null;
            }
          }
        }
        if(ele.signature.object == 'CUSTOMER'){
          if(listSignCus.length > 0){
            const a = listSignCus.filter(ala => {
              return ala.signatureId == ele.signature.signatureId;
            });
            if(a.length > 0){
              // ele.name = a[0].name;
              ele.signature.positions.forEach(element =>{
                element.name = a[0].name;
              })
              ele.customerId = a[0].customerId;
            }
            else {
              ele.customerId = null;
            }
          }
        }
        if(ele.signature.object == 'CUSTOMERAPPROVER'){
          if(listSignCusApprove.length > 0){
            const a = listSignCusApprove.filter(ala => {
              return ala.signatureId == ele.signature.signatureId;
            });
            if(a.length > 0){
              // ele.name = a[0].name;
              ele.signature.positions.forEach(element =>{
                element.name = a[0].name;
              })
              ele.userId = a[0].userId;
            }
            else {
              ele.userId = null;
            }
          }
        }
      })
        // this.dataFootNote = this.dataFootNote.map(item => {
        //     if (item.signature && item.signature.signatureId && data.signature && data.signature.signatureId && item.signature.signatureId !== data.signature.signatureId) {
        //         if (item.customerId === event) {
        //             item.customerId = null;
        //         }
        //         if (item.userId === event) {
        //             item.userId = null;
        //         }
        //     }
        //     return item;
        // });
        this.createContractMohaService.signatureData.next(this.dataFootNote);
      localStorage.removeItem('dataSignature')
      console.log(this.listDataPeople[j].customerApproves[i].page)
    }

    checkDisabledOption(id) {
        const selected = this.dataFootNote.find(item => item.customerId === id);
        return selected ? true : false;
    }
}
